import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoIntegrations = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.52112 32.4777C11.7085 36.4657 16.6935 34.8705 18.6875 33.2553C19.7192 32.4197 20.183 31.8795 20.5818 31.4807C21.9776 30.1846 21.8878 28.8885 20.9806 27.8516C20.6175 27.4367 18.2887 25.1996 16.0554 22.9065C14.8989 21.7498 14.1013 20.9325 13.4194 20.2744C12.5061 19.3641 11.7085 18.3203 10.5121 18.3502C9.41542 18.3502 8.61782 19.3173 7.62082 20.3143C6.4739 21.4612 5.62683 22.9065 5.32773 24.2026C4.43044 27.9912 5.82623 30.6831 7.52112 32.4777ZM7.52112 32.4777L3.33374 36.6651",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M32.478 7.52433C28.2895 3.53444 23.3217 5.15968 21.3272 6.77559C20.2952 7.61166 19.8313 8.1521 19.4324 8.55109C18.0362 9.84781 18.1259 11.1445 19.0335 12.1819C19.164 12.3311 19.5488 12.7161 20.0919 13.2545M32.478 7.52433C34.1734 9.31978 35.5881 12.0422 34.6905 15.8326C34.3914 17.1294 33.5441 18.5753 32.3968 19.7228C31.3996 20.7203 30.6017 21.6878 29.5048 21.6878C28.308 21.7177 27.687 20.8524 26.7735 19.9416M32.478 7.52433L36.6665 3.33496M26.7735 19.9416C26.0914 19.2833 25.1168 18.2866 23.96 17.1294C22.5292 15.66 21.0593 14.2136 20.0919 13.2545M26.7735 19.9416L24.1708 22.4825M17.519 15.8433L20.0919 13.2545",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})]
});
export default SvgNoIntegrations;
